import { noop } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import { defineMessages } from 'react-intl';
import styled from 'styled-components';
import { HStack } from '../Core';
import { FormControlSizes, Toggle } from '../Form';
import { IconName } from '../Icons';
import { FormattedMessage } from '../Intl';
import { useSidebarContext } from './SidebarContext';
import { SidebarItem, type SidebarItemProps } from './SidebarItem';

const messages = defineMessages({
  pinSidebar: {
    id: 'Sidebar.pinSidebar',
    defaultMessage: 'Pin Sidebar',
  },
});

interface SidebarPinToggleProps extends PropsWithChildren<Omit<SidebarItemProps, 'icon' | 'onClick'>> {
  onChange?: (pinned: boolean) => void;
}

export const SidebarPinToggle = styled(function SidebarPinToggle({
  children,
  onChange,
  ...props
}: SidebarPinToggleProps) {
  const { isPinned, setPinned } = useSidebarContext();
  const handleClick = () => {
    const newPinnedState = !isPinned;
    setPinned(newPinnedState);
    onChange && onChange(newPinnedState);
  };

  return (
    <SidebarItem onClick={handleClick} icon={isPinned ? IconName.SidebarPinned : IconName.SidebarUnpinned} {...props}>
      <HStack justifyContent="space-between" w="100%" overflow="hidden">
        <FormattedMessage {...messages.pinSidebar} />
        <Toggle onChange={noop} checked={isPinned} size={FormControlSizes.Small} />
      </HStack>
    </SidebarItem>
  );
})``;
